import { makeStyles } from '@material-ui/core';
import { itemStyles } from '../../HelpCenterList.styles';

export default makeStyles((theme) => ({
  ...itemStyles(theme),
}));
